module.exports = __webpack_public_path__ + "img/Longest-fang-snake.c43d3240.jpg";